module.exports = __webpack_public_path__ + "img/unifgua.1404f079.svg";